"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedState = useDebouncedState;
const react_1 = require("react");
/** Hook to debounce a state. Returns normal value and setter and a third, debounced output */
function useDebouncedState(initialValue, delay) {
    const [value, setValue] = (0, react_1.useState)(initialValue);
    const [debouncedValue, setDebouncedValue] = (0, react_1.useState)(initialValue);
    (0, react_1.useEffect)(() => {
        const timeout = setTimeout(() => setDebouncedValue(value), delay);
        return () => clearTimeout(timeout);
    }, [value]);
    return [value, setValue, debouncedValue];
}
